import DeliveryNoteIcon from 'assets/dialogue-avatar-delivery-note.svg';
import TrackingSupportIcon from 'assets/dialogue-avatar-tracking-support.svg';
import { DialogueCardData, DialogueType } from 'models/DialogCard';

const latestEventCards: { [key: string]: DialogueCardData } = {
  'TTP-ER8': {
    analyticsId: 'latestEventIncorrectlySorted',
    icon: <TrackingSupportIcon />,
    type: DialogueType.TRACKING_SUPPORT,
    title: 'Okay, it’s back on track again',
    content: (
      <>
        <p>This parcel was incorrectly sorted and arrived at the wrong processing facility.</p>
        <p>It’s now heading in the right direction, but there may be a slight delay. Sorry about that.</p>
      </>
    ),
  },
  'DD-ER8': {
    analyticsId: 'latestEventLocationNotSuitable',
    icon: <DeliveryNoteIcon />,
    type: DialogueType.DELIVERY_NOTE,
    title: 'It wasn’t safe to leave it',
    content: (
      <>
        <p>The postie decided the location or conditions made it unsafe to leave this parcel.</p>
        <p>It’s now heading to a local Post Office for collection.</p>
      </>
    ),
  },
  'DD-ER3': {
    analyticsId: 'latestEventIncorrectAddress',
    icon: <DeliveryNoteIcon />,
    type: DialogueType.DELIVERY_NOTE,
    title: 'Looks like it was addressed incorrectly',
    content: (
      <>
        <p>We couldn’t deliver this parcel because the address was incorrect, incomplete or unclear.</p>
        <p>We’re returning it to the sender, who’ll need to arrange re-delivery.</p>
      </>
    ),
  },
};

export function getLatestEventCard(latestEventCode: string | null) {
  if (!latestEventCode) return null;

  return latestEventCards[latestEventCode] || null;
}
